import React from "react";
import styled from "styled-components";
import getImageURL from "../../../../controllers/getImageURL";
import formatDate from "../../../../controllers/formatDate";
import SemanticButton from "../../../helperComponents/SemanticButton";
import MessageBox from "../../../helperComponents/MessageBox";
import { useTranslation } from "react-i18next";

const Card = styled.div`
  border-radius: 10px;
  width: 350px;
  height: 300px;
  overflow: hidden;
  color: white;
  position: relative;
  transition: all 0.25s ease-in-out;
  cursor: pointer;

  &:hover {
    transform: scale(0.95);
  }

  background: var(--surface);
  border: 1px solid var(--border);
  color: var(--element);

  @media (max-width: 900px) {
    width: calc((90vw - 20px) / 2);
    height: 44vw;
  }
`;

const ImageContainer = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const Badge = styled.div`
  position: absolute;
  top: 15px;
  left: 15px;
  background-color: #303030;
  padding: 5px 15px;
  border-radius: 20px;
  font-size: 14px;
  color: var(--element);
  font-weight: bold;
`;

const InfoContainer = styled.div`
  padding: 20px;
  padding-top: 150px;
  position: absolute;
  bottom: 0;
  background: linear-gradient(1deg, black, 50%, transparent);
  width: 100%;
  left: 0;
  border-radius: 0;
  gap: 10px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const Title = styled.h2`
  font-size: 16px;
  font-weight: 900;
  font-family: var(--headingFont);
  color: var(--accentColor);
  text-align: left;

  text-transform: capitalize;
  margin: 0;

  @media (max-width: 900px) {
    font-size: 15px;
  }
`;

const Subtitle = styled.div`
  font-size: 14px;
  font-weight: 900;
  color: var(--accentColor);
  filter: saturate(0.3);
  font-family: var(--headingFont);

  @media (max-width: 900px) {
    font-size: 11px;
  }
`;

export default function StoreItemCard({ item }) {
  const { t } = useTranslation();

  // if (!item.currentStock) return null;

  if (!item.images) item.images = [];

  return (
    <SemanticButton href={`/store-item/?itemID=${item._id}`}>
      <Card>
        <ImageContainer>
          <Image src={getImageURL(item.images[0])} alt="" />
        </ImageContainer>
        <InfoContainer>
          <Title>{item.title}</Title>
          <Subtitle>{item.price} CFA</Subtitle>
          {item.currentStock ? null : (
            <MessageBox>{t("outOfStock")}</MessageBox>
          )}
        </InfoContainer>
      </Card>
    </SemanticButton>
  );
}
